import {FC} from "react";
import {Tooltip} from "react-tooltip";

interface IProps {
  countActive: number;
  imgActive: string;
  id: string | number;
  tooltip?: string;
  size?: "xs" | "sm" | "md" | "lg";
}

export const SnippetShowThreeIcons: FC<IProps> = ({
  countActive,
  imgActive,
  id,
  tooltip,
  size = "sm",
}) => {
  return (
    <div
      style={{
        color: "#fff",
        fontSize: 14,
        display: "flex",
        gap: size === "xs" ? 2 : 5,
      }}
      id={`${id}`}
      data-tooltip-id={`${id}`}
      data-tooltip-content={tooltip}
    >
      {[1, 2, 3].map((item) => {
        return (
          <img
            key={item}
            src={imgActive}
            alt={"DollarIcon"}
            width={
              size === "xs"
                ? "15"
                : size === "sm"
                ? "20"
                : size === "md"
                ? "30"
                : size === "lg"
                ? "40"
                : "10"
            }
            height={
              size === "xs"
                ? "15"
                : size === "sm"
                ? "20"
                : size === "md"
                ? "30"
                : size === "lg"
                ? "40"
                : "10"
            }
            style={item <= countActive ? {opacity: 1} : {opacity: 0.5}}
          />
        );
      })}
      <Tooltip
        id={`${id}`}
        className="tooltip"
        place={"bottom-start"}
        noArrow
      />
    </div>
  );
};
